var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.studentSieId)?_c('div',[_c('page-header',{attrs:{"actions":_vm.headerActions,"page":{
      icon: 'fas fa-file-contract',
      title: 'Historial de Querellas',
      routes: ['Inicio', 'Historial de Querellas'],
    }}}),_c('complains-history',{attrs:{"student-sie-id":Number(_vm.studentSieId)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }